/**
 * Generate the UUID used to identify one client-side write operation.
 *
 * Callers should create this once when a user starts a write and reuse it for
 * retries of that same request. The API can then return the original result
 * instead of creating a second record after a response is lost.
 */
export function createIdempotencyKey(): string {
  const runtimeCrypto = globalThis.crypto;
  if (runtimeCrypto?.randomUUID) return runtimeCrypto.randomUUID();

  const randomHex = (length: number) =>
    Array.from({ length }, () =>
      Math.floor(Math.random() * 16).toString(16),
    ).join("");
  const variant = (8 + Math.floor(Math.random() * 4)).toString(16);
  return `${randomHex(8)}-${randomHex(4)}-4${randomHex(3)}-${variant}${randomHex(3)}-${randomHex(12)}`;
}
